import React, { useMemo } from "react";

import { useTheme } from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import NativeSelect from "@meetyoo/components/src/components/Selects/NativeSelect";

export function useDefaultPasscodeStyles() {
  const theme = useTheme();
  return useMemo(() => defaultPasscodeTheme(theme), [theme]);
}

export const defaultPasscodeTheme = theme => ({
  container: {
    display: "flex",
    flexWrap: "wrap",
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  lineBreak: {
    width: "100%",
  },
  lineExpander: {
    flexGrow: 1,
  },
  switch: {
    margin: theme.spacing(1, 1, 1, 1),
    width: "5%",
  },
  button: {
    margin: theme.spacing(2, 1, 1, 1),
  },
  centerer: {
    textAlign: "center",
    width: "100%",
  },
  inline: {
    display: "flex",
    width: "100%",
  },
});

export const getKeyFromSelectedValue = (object, selectedValue) => {
  return Object.keys(object).filter(storeKey => object[storeKey] === selectedValue)[0];
};

export const getSelectedValueTranslated = (selectedValue, selectableValues, selectKey) => {
  return selectableValues[selectKey][selectedValue];
};

export const getSelectValues = (selectableValues, selectKey) => {
  return Object.keys(selectableValues[selectKey]).map(key => selectableValues[selectKey][key]);
};

/** @param pc Return value of {@link useDefaultPasscodeStyles} / {@link defaultPasscodeTheme} */
export const textfield = (pc, isDesktop, value, label, onChange) => (
  <TextField
    id="standard-name"
    label={label}
    sx={[pc.textField, isDesktop ? pc.lineExpander : null].filter(Boolean)}
    value={value || ""}
    onChange={onChange}
    margin="normal"
  />
);

/** @param pc Return value of {@link useDefaultPasscodeStyles} / {@link defaultPasscodeTheme} */
export const switchControl = (pc, checked, value, label, onChange) => {
  const isChecked = checked === 1 || checked === true;
  return (
    <FormControlLabel
      sx={[pc.switch, pc.lineExpander]}
      control={<Switch checked={isChecked} onChange={onChange} value={value} color="primary" />}
      label={label}
    />
  );
};

export const selectField = (customStyle, value, selectValues, defaultSelect, onChange, isDesktop = true) => (
  <NativeSelect
    customStyle={customStyle}
    isDesktop={isDesktop}
    value={value}
    defaultSelect={defaultSelect}
    selectValues={selectValues}
    onChange={onChange}
  />
);
